import { LoaderFunctionArgs } from 'react-router-dom'
import { getPaymentStatus } from '../api/getPaymentStatus'
import { PaymentResult } from '../types/PaymentResult'

const paymentResultPageLoader = async ({ params }: LoaderFunctionArgs): Promise<PaymentResult> => {
    const { paymentPageId, transactionId } = params

    if (!paymentPageId || !transactionId) {
        throw new Error('Payment page ID and transaction ID are required')
    }

    return await getPaymentStatus(paymentPageId, parseInt(transactionId, 10))
}

export default paymentResultPageLoader
